var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('QuoteDetailsVue',{attrs:{"currencies":_vm.currencies,"quotation_id":_vm.$route.params.quotation_id,"supplier_id":_vm.$route.params.supplier_id,"itbis":_vm.itbis}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }